module.exports = [
  {
    key: 'INFANT',
    label: {
      en: 'Infant',
      es: 'Bebé',
    },
  },
  {
    key: 'CHILD',
    label: {
      en: 'Child',
      es: 'Niño',
    },
  },
  {
    key: 'ADULT',
    label: {
      en: 'Adult',
      es: 'Adulto',
    },
  },
  {
    key: 'OBESE',
    label: {
      en: 'Obese',
      es: 'Obeso',
    },
  },
];
